<div class="subBlockContainer" id="createtenant">
  <div class="subBlockContent">        
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div class="inner-subBlock-wrapper">
        <!-- <div id="upload-sku"> -->
          <!-- <mat-tab-group class="mat-tab-labels" (selectedTabChange)="myTabSelectedTabChange($event)">
            <mat-tab label="Change Reseller"> -->
              <!-- <div class="tab-content" id="pills-tabContent"> -->
                <div [formGroup]="userFormGroup" class="col-md-12">
                  <div class="userinfo" style="margin: 50px 0px 20px 25px;">
                    <div>
                      <mat-form-field [floatLabel]="'always'" style="width: 50%;">
                        <input matInput class="approvalCodeValidate" formControlName="approvalCode" placeholder="APPROVAL CODE" required>
                      </mat-form-field>
                    </div>
                    <!-- <div>
                      <mat-form-field [floatLabel]="'always'" style="width: 50%;">
                        <input matInput class="resellerIdValidate" formControlName="resellerId" placeholder="RESELLER ID" required>
                      </mat-form-field>
                    </div> -->
                    <div>                    
                      <mat-form-field [floatLabel]="'always'" style="width: 50%;">
                        <input matInput class="requestedByValidate" placeholder="REQUESTED BY" formControlName="requestedBy" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="margin: 20px 0px 50px 25px;">
                    <button class="button button-red button-round"
                      (click)="previewAssociation()"
                      [disabled]="previewResult?.length || preivewLoading || !resellerId">
                      &nbsp;Association Preview&nbsp;
                    </button>
                    <button *ngIf="previewResult?.length" class="button button-red button-round"
                      style="margin-left: 5px;"
                      [disabled]="disableRequest"
                      (click)="resetPage()"
                      >
                      &nbsp;Reset Page&nbsp;
                    </button>
                  </div>
                  <div style="margin: 20px 0px 50px 25px;">
                    <mat-spinner style="margin: auto;" mode="indeterminate"
                      class="circle cSPCustomerEntitlements-loading" diameter="20"
                      *ngIf="preivewLoading">
                    </mat-spinner>
                  </div>
                  <div class="my-4" *ngIf="previewResult?.length" style="margin: 20px 0px 50px 25px;" >
                    <div style="overflow-y: auto; height: 500px;">
                      <table mat-table [dataSource]="previewResult">
  
                        <ng-container matColumnDef="subscriptionId">
                          <th class="align-center table-column" *matHeaderCellDef width="30%">SUBSCRIPTION ID</th>
                          <td class="align-center tb-row" *matCellDef="let element" style="white-space: pre;">
                            {{ element.subscriptionId }}
                          </td>
                        </ng-container>
  
                        <!-- <ng-container matColumnDef="lineItemNumber">
                          <th class="align-center le-column" *matHeaderCellDef width="10%">LINE ITEM NO.</th>
                          <td class="align-center tb-row" mat-cell *matCellDef="let element" style="white-space: pre;">
                            {{ element.lineItemNumber }}
                          </td>
                        </ng-container> -->
  
                        <ng-container matColumnDef="offerId">
                          <th class="align-center table-column" *matHeaderCellDef width="15%">OFFER ID</th>
                          <td class="align-center tb-row" *matCellDef="let element" style="white-space: pre;">
                            {{ element.offerId }}
                          </td>
                        </ng-container>
  
                        <ng-container matColumnDef="offerName">
                          <th class="align-center table-column" *matHeaderCellDef width="30%">OFFER NAME</th>
                          <td class="align-center tb-row" *matCellDef="let element" style="white-space: pre;">
                            <div
                              style="white-space: nowrap; width: 250px; overflow: hidden; text-overflow: ellipsis;"
                              matTooltip="{{element.stockDescription}}"
                            >
                              {{ element.stockDescription }}
                            </div>
                          </td>
                        </ng-container>
  
                        <ng-container matColumnDef="renewalDate">
                          <th class="align-right table-column" *matHeaderCellDef width="15%">RENEWAL DATE</th>
                          <td class="align-right tb-row" *matCellDef="let element" style="white-space: pre;">
                            {{ element.renewalDate | date: 'dd/MM/yyyy'}}
                          </td>
                        </ng-container>
  
                        <ng-container matColumnDef="quantity">
                          <th class="align-right table-column" *matHeaderCellDef width="10%">QTY</th>
                          <td class="align-right tb-row" *matCellDef="let element" style="white-space: pre;">
                            {{ element.quantity }}
                          </td>
                        </ng-container>
  
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                    </div>
                    
         
      
                  </div>
  
                  <div class="noResult-wrapper" style="margin-top: 55px;" *ngIf="showNoPreviewResult" style="margin: 20px 0px 50px 25px;">
                    <div><img src="../images/new_ui/no-found.png"></div>
                    <div>No active subscriptions available for this customer</div>
                  </div>
                  <div *ngIf="showNoPreviewResult || previewResult?.length" style="margin: 20px 0px 50px 25px;">
                    <button
                      class="button button-red button-round"
                      style="margin-left: 750px; margin-top: 10px;"
                      [disabled]="disableRequest || !authService?.currentUserHasPurchaseAccess()"
                      [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"
                      matTooltip="Requires Purchasing Permissions"
                      (click)="commitAssociation()"
                      >
                      &nbsp;Request Association&nbsp;
                    </button>
                  </div>
                </div>
                
              <!-- </div> -->
            <!-- </mat-tab> -->
            <!-- <mat-tab label="In-Progress">
              <div class="tab-content" id="pills-tabContent">
                <div class="my-4">
                  <div>
                    <mat-spinner style="margin: auto;" mode="indeterminate"
                      class="circle cSPCustomerEntitlements-loading" diameter="20"
                      *ngIf="preivewLoading">
                    </mat-spinner>
                  </div>
                  <div class="my-4" *ngIf="previewResult?.length" >
                    <div style="overflow-y: auto; height: 500px;">
                      <table mat-table [dataSource]="previewResult">
                        <ng-container matColumnDef="transferId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="28%" class="align-left"
                            class="table-column">TRANSFER ID</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="28%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.transferId }}</td>
                        </ng-container>
                        <ng-container matColumnDef="resellerId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                            class="table-column">RESELLER ID</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.resellerId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="customerId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="20%" class="align-left"
                            class="table-column">CUSTOMER ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="22%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.customerID}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                            class="table-column">STATUS</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="offerId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                            class="table-column">OFFER ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.offerId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="quantity">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                            class="table-column">QTY</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.quantity}}</td>
                        </ng-container>
                        <ng-container matColumnDef="renewalDate">
                          <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                            mat-header-cell *matHeaderCellDef width="15%">RENEWAL DATE</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.renewalDate }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Completed">
              <div class="tab-content" id="pills-tabContent">
                <div class="my-4">
                  <div>
                    <mat-spinner style="margin: auto;" mode="indeterminate"
                      class="circle cSPCustomerEntitlements-loading" diameter="20"
                      *ngIf="preivewLoading">
                    </mat-spinner>
                  </div>
                  <div class="my-4" *ngIf="previewResult?.length" >
                    <div style="overflow-y: auto; height: 500px;">
                      <table mat-table [dataSource]="previewResult">
                        <ng-container matColumnDef="transferId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="28%" class="align-left"
                            class="table-column">TRANSFER ID</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="28%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.transferId }}</td>
                        </ng-container>
                        <ng-container matColumnDef="resellerId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                            class="table-column">RESELLER ID</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.resellerId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="customerId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="20%" class="align-left"
                            class="table-column">CUSTOMER ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="22%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.customerID}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                            class="table-column">STATUS</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="offerId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                            class="table-column">OFFER ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.offerId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="quantity">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="5%" class="align-left"
                            class="table-column">QTY</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.quantity}}</td>
                        </ng-container>
                        <ng-container matColumnDef="renewalDate">
                          <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                            mat-header-cell *matHeaderCellDef width="15%">RENEWAL DATE</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="5%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.renewalDate }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                    </div>
                  </div>
                </div>
                <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)">
                </loading-screen>
              </div>
            </mat-tab> -->
          <!-- </mat-tab-group> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>